

const initContentHomeWebsiteTemplate : any = {
   banner:'assets/img/interface-store/banner/banner trang kho website.jpg',
   hotline:'0934.60.60.60',
   email:'viethas.info@gmail.com',
   image_description:'assets/img/interface-store/image/TANG WEBSITE-13.svg',
}


const initContentHomeAppTemplate : any = {
    banner:'assets/img/interface-store/banner/banner trang kho App.jpg',
    primary_color:'#F99B3E',
    hotline:'0934.60.60.60',
    email:'viethas.info@gmail.com',
    image_description:'assets/img/interface-store/image/TANG WEBSITE-13.svg',
 }
 
export { initContentHomeWebsiteTemplate , initContentHomeAppTemplate}
